export const HOME_HOOK_NAME = "NeedMoreProjects";

export const DEFAULT_LIST_WIDTH = 1000;
export const LIST_HEIGHT = 440;
export const LIST_ROW_HEIGHT = 88;
export const SEARCH_DEBOUNCE_MS = 200;
export const TOOLTIP_DELAY = 500;

export const EMPTY_PROJECT_LIST_SRC = "/images/activation/cactus.svg";
export const ERROR_PROJECT_LIST_SRC = "/images/activation/Microscope.svg";
export const EMPTY_PROJECT_FOLDERS_SRC = "/images/activation/folders.svg";
